var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 165,
    height: 88,
    viewBox: "0 0 165 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "214%",
    height: "214%",
    x: "-57%",
    y: "-57%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 9.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.135762675 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M17.964.5L0 17.912v11.506L19.687 48.5 35 11.723z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    stroke: "#EAEAEA",
    strokeWidth: 2,
    d: "M124 7a2 2 0 0 0-2 2v74a2 2 0 0 0 2 2h38a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-38zm-1 2h40v70h-40V9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD00",
    d: "M130 45l-3 3v-3a1 1 0 0 1-1-1V34a1 1 0 0 1 1-1h32a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-29zm-1-9v2h29v-2h-29zm0 4v2h13v-2h-13z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 19)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EE2E3D",
    fillRule: "nonzero",
    d: "M50.985 39.985V34l-3.746 3.566L43.418 34l-3.672 3.566L36 34v18.888C36 54.05 36.93 55 38.083 55h.045c1.139 0 2.068-.949 2.068-2.112v-3.612h6.593V52.888c0 1.163.93 2.112 2.083 2.112h.045C50.071 55 51 54.051 51 52.888v-9.98l-.015-2.923zm-10.79 5.387v-1.714c0-1.852 1.484-3.352 3.298-3.352 1.813 0 3.296 1.5 3.296 3.352v1.714h-6.593z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77 20.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#EAEAEA",
    strokeWidth: 3,
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.79 44.351c2.055-1.86 3.841-4 5.297-6.356a28.582 28.582 0 0 0 4.282-15.075c0-10.895-6.103-20.397-15.151-25.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.389 39.452c4.818-3.962 7.88-9.897 7.88-16.532 0-8.513-5.042-15.876-12.367-19.393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.506 34.057c.61-.452 1.183-.952 1.711-1.493C5.666 30.056 7.17 26.66 7.17 22.92c0-3.365-1.217-6.452-3.245-8.864A14.29 14.29 0 0 0 0 10.806"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmPhone);
export default __webpack_public_path__ + "static/media/confirm-phone.6e3f3978b2d07453f40e8cb7ca886d56.svg";
export { ForwardRef as ReactComponent };